import { useState } from 'react';
import { Link } from 'react-router-dom';
import { TimesCircle2X } from '../shared/icons';
import { TOP_NAV_LOGO } from '../shared/assets';
import './nav.css';


export default () => {
  const links = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/team', label: 'Our Team' },
    { path: '/projects', label: 'Our Projects' },
    { path: '/contact', label: 'Contact Us' },
  ];
  
  return <>
    <div className="top-ribbon"></div>
    <header className="global-header">
      <a className="site-logo" href="/">
        <img src={TOP_NAV_LOGO} alt="NRNA Australia Logo" />
      </a>
      <Masternav className="master-nav" links={links}/>
      <HamburgerIcon links={links}/>
    </header>
  </>
}


const Masternav = ({ className, links }) => {
  return <nav className={className}>
    <ul className="nav" role="list">
      {
        links.map(link => {
          return <li className="nav__list" key={link.path}>
            <Link className="nav__link" to={link.path}>{link.label}</Link>
          </li>
        })
      }
    </ul>
  </nav>
}

const HamburgerIcon = ({links}) => {
  const [open, setOpen] = useState(false);
  return <div className="hamburger-container" onClick={() => setOpen(!open)}>
    <div className="hamburger">
      <div className="hamburger-bar" />
      <div className="hamburger-bar" />
      <div className="hamburger-bar" />
    </div>
    <div className={`hamburger-slide-in  ${open ?'slide-in-hidden' : 'slide-in-shown' }`}>
      <section className="menu">
        <div className="close-button" onClick={() => setOpen(!open)}>
          <TimesCircle2X/>
          <span>Close</span>
        </div>
        <ul className="menu-list">
          {links.map(link => <li className="menu-list-item" key={link.path}>
            <Link to={link.path}>{link.label}</Link>
          </li>)}
        </ul>
      </section>
    </div>
  </div>
}